export default __webpack_public_path__ + "static/media/IMG-20241210-WA0026.175057eb.jpg";